module.exports = __webpack_public_path__ + "img/exit-btn.7c0bb2ca.png";